<div class="content" role="main">
  <h2>Recommendation Call</h2>
  <p id="text-center"> Get three recommendations from one product, the recommendations are always analysed against all the lists of alerts and the added INCI if any is added</p>

  <form class="forms widthMax" [formGroup]="getRecommendationsForm" (ngSubmit)="onSubmit()">

    <mat-form-field appearance="fill">
      <mat-label>EAN</mat-label>
      <input matInput type="number" placeholder="123456789101" [formControl]="getRecommendationsForm.controls.EAN" >
      <mat-hint> Type the EAN of the product you want recommendation from eg 11093770</mat-hint>

    </mat-form-field>

    <mat-form-field class="chip-list widthMax">
      <mat-chip-list #chipListPersonalList >
        <ng-container *ngTemplateOutlet="chip context: personalListChipElement"></ng-container>
        <input
          placeholder="Add INCI to analyse the product against..."
          #personalListInput
          [formControl]="personalListCtrl"
          [matChipInputFor]="chipListPersonalList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matAutocomplete]="autoPersonalList">
      </mat-chip-list>
      <mat-autocomplete #autoPersonalList="matAutocomplete" (optionSelected)="selected($event,personalListCtrl, personalListChipElement.arrayString, personalListChipElement.formArrayName, true)">
        <mat-option *ngFor="let INCI of usefulFunctionsService.possibleINCIs" [value]="INCI">
          {{INCI}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>


    <button mat-raised-button color="accent" type="submit" class="margin" [disabled]="!getRecommendationsForm.valid || !getRecommendationsForm.value.EAN">Submit</button>

  </form>

<!--  <p> Form Values: {{getRecommendationsForm.value | json}}</p>-->

  <button mat-raised-button color="primary" type="button" class="margin" (click)="usefulFunctionsService.downloadData(results, 'Recommendations')" [disabled]="!results">Download Results</button>

  <mat-card *ngFor="let product of results" class="example-card">
    <mat-card-header>
      <mat-card-title>{{product.name}} {{product.size}}</mat-card-title>
      <mat-card-subtitle>{{product.EAN}}</mat-card-subtitle>
    </mat-card-header>
    <img mat-card-image src="{{product.image}}" alt="Photo of the product">
    <mat-card-content>
      <p><span class="title">Year:</span> {{product.date_submitted.slice(0,4)}}</p>

      <p class="title">Category / Sub category</p>
      <p>{{product.category_name}} / {{product.sub_category}}</p>

      <p *ngIf="!someAlerts(product)"><span class="title">Alerts:</span> None</p>
      <ng-container *ngFor="let alert of product.alertsDisplay"><p *ngIf="alert.INCI.length > 0"><span  class="title"> {{alert.name }}</span> : {{alert.INCI }}</p></ng-container>
      <p><span class="title">Personal INCI found in the product:</span> {{product.alerts["personal list"] && product.alerts["personal list"].length > 0 ? product.alerts["personal list"] : "None"}} </p>


    </mat-card-content>
  </mat-card>

</div>


<!-- TEMPLATES -->

<!-- Chip Element -->
<ng-template #chip let-arrayString="arrayString" let-formArrayName="formArrayName">
  <mat-chip
    *ngFor="let string of arrayString"
    [selectable]="selectable"
    [removable]="removable"
    (removed)="chipListComponent.remove(string, arrayString,formArrayName, this.getRecommendationsForm)">
    {{string}}
    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
  </mat-chip>
</ng-template>

<!-- mat-action-row -->
<ng-template #matActionRow let-firstStep="firstStep" let-disabled="disabled">
  <mat-action-row>
    <button *ngIf="!firstStep" mat-button color="warn" type="button" (click)="prevStep()">Previous</button>
    <button mat-button color="primary" type="button" [disabled]="disabled" (click)="nextStep()">Next</button>
  </mat-action-row>
</ng-template>
